/**
 * Returns a new date with the time set to 00:00:00.
 * @param date Date to convert.
 * @returns The new date with the time set to 00:00:00.
 * @example
 * toDateWithoutTime(new Date('2021-01-01T12:34:56.789Z')); // Returns new Date('2021-01-01T00:00:00.000Z')
 * toDateWithoutTime(new Date('2021-01-01T00:00:00.000Z')); // Returns new Date('2021-01-01T00:00:00.000Z')
 */
export function toDateWithoutTime(date: Date): Date {
	// Cast parameter to Date
	date = new Date(date);

	// Result
	return new Date(
		date.getFullYear(),
		date.getMonth(),
		date.getDate(),
		0,
		0,
		0,
		0,
	);
}
